module.exports = __webpack_public_path__ + "img/B23-20190415_06.a529b101.jpg";